import { useCallback, JSX } from 'react';
import { Platform, StyleSheet } from 'react-native';
import {
	MenuGroup as MenuGroupKitten,
	MenuItem as MenuItemKitten,
	OverflowMenu as OverflowMenuKitten,
	MenuItemProps as MenuItemPropsKitten,
	MenuGroupProps as MenuGroupPropsKitten,
	OverflowMenuProps,
} from '@ui-kitten/components';
import { EvaStatus } from '@ui-kitten/components/devsupport';

import { spacing, colors, shadows } from '../../theme';
import { Text } from '../Text';

export const OverflowMenu = ({ style, ...props }: OverflowMenuProps) => {
	return <OverflowMenuKitten placement="bottom end" style={[styles.menu, style]} {...props} />;
};

interface ItemProps {
	title: string | JSX.Element;
	status?: EvaStatus;
	appearance?: 'default' | 'alternative' | 'hint';
}
export type MenuItemProps = ItemProps & Omit<MenuItemPropsKitten, 'title'>;
export type MenuGroupProps = ItemProps & Omit<MenuGroupPropsKitten, 'title'>;

const textCategory = Platform.OS === 'web' ? 'c2' : 'p2';

export const MenuItem = ({ title, status, appearance, style, ...menuItemProps }: MenuItemProps) => {
	const renderTitle = useCallback(
		() => (
			<Text
				category={textCategory}
				status={status ?? 'primary'}
				appearance={appearance ?? 'default'}
			>
				{title}
			</Text>
		),
		[appearance, status, title],
	);

	return <MenuItemKitten title={renderTitle} style={[styles.menuItem, style]} {...menuItemProps} />;
};

export const SubMenuItem = (props: MenuItemProps) => {
	return <MenuItem {...props} style={styles.subMenuItem} />;
};

export const MenuGroup = ({ title, status, ...menuGroupProps }: MenuGroupProps) => {
	return (
		<MenuGroupKitten
			title={() => (
				<Text category={textCategory} status={status ?? 'primary'}>
					{title}
				</Text>
			)}
			style={styles.menuItem}
			{...menuGroupProps}
		/>
	);
};

const styles = StyleSheet.create({
	menu: {
		borderRadius: spacing(),
		minWidth: 162,
		borderWidth: 1,
		borderColor: colors.neutral400,
		...shadows.drop2,
	},
	menuItem: {
		paddingHorizontal: spacing(2),
		paddingVertical: 11,
		...Platform.select({
			web: {
				outlineWidth: 1,
				outlineOffset: -4,
			},
		}),
	},
	subMenuItem: {
		paddingHorizontal: spacing(3),
		paddingVertical: 11,
	},
});
